/**
 * Command contract version — `"major.minor"`, e.g. "1.0".
 *
 * It versions the command vocabulary and the shape of `params`, not the
 * transport.
 *
 * major — a breaking change: a parameter renamed, removed or re-typed, a
 *         command that changes meaning, a value dropped from a list. The UI
 *         refuses a major it does not know.
 * minor — an addition that older builds can ignore: a new command, a new
 *         optional parameter. The UI accepts any minor, including one higher
 *         than it knows; unrecognised commands and parameters are ignored.
 *
 * To support a second major, add it below and branch inside the handlers that
 * actually changed.
 */

/** Assumed when the sender omits `metadata.version`. */
export const DEFAULT_COMMAND_VERSION = "1.0";

/** Majors this build can carry out. */
export const SUPPORTED_MAJOR_VERSIONS = [1];

/** Accepts "1.0", "1", "v1.0" or 1. Returns null if it is none of those. */
export function parseVersion(
  value: unknown,
): { major: number; minor: number } | null {
  const match = /^v?(\d+)(?:\.(\d+))?$/.exec(String(value).trim());
  if (!match) return null;
  return { major: Number(match[1]), minor: Number(match[2] ?? 0) };
}
